import { Link } from 'react-router-dom';

interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  moreLink?: string;
  moreText?: string;
}

export default function SectionHeader({ eyebrow, title, description, moreLink, moreText }: SectionHeaderProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 text-xs font-bold tracking-wider text-accent-600">
            <span className="h-1 w-4 rounded-full bg-accent-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">{title}</h2>
        {description && <p className="mt-2 max-w-2xl text-sm text-foreground-500">{description}</p>}
      </div>
      {moreLink && (
        <Link
          to={moreLink}
          className="group flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
        >
          {moreText || '查看更多'}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
        </Link>
      )}
    </div>
  );
}